<section class="ft-master-section ft-touchpoint-master">
  <ft-pending-changes-panel-ng #panel [live]="model().emailsData" [inactive]="panelInactive()"
                               (save)="onPanelSave($event)" (cancelled)="onPanelCancel()" />
  <ft-field-editor-modal [config]="fieldEditorConfig()" (closed)="fieldEditorConfig.set(null)" />

  <section class="ft-section ft-config-section">
    <div class="ft-container">
      <div class="main-summary" [innerHTML]="'flipto.account.CertificateEmailHeading' | translate"></div>

      <div class="carousel ft-v-align-container">
        <div class="ft-v-align-content">
          <div class="carousel-item">
            @for (item of carouselItems(); track item; let i = $index) {
              <span [hidden]="carouselIndex() !== i"><span [innerHTML]="item.key | translate"></span></span>
            }
          </div>
          <div class="carousel-item-dots">
            @for (item of carouselItems(); track item; let i = $index) {
              <div class="carousel-item-dot" (click)="carouselSelect(i)" [class.active]="carouselIndex() === i"></div>
            }
          </div>
          <div class="carousel-nav">
            <button class="ft-btn btn-left" (click)="carouselLeft()" [disabled]="!canGoLeft()" [class.disabled]="!canGoLeft()">
              <span class="ft-icn-caret-left"></span>
            </button>
            <button class="ft-btn btn-right" (click)="carouselRight()" [disabled]="!canGoRight()" [class.disabled]="!canGoRight()">
              <span class="ft-icn-caret-right"></span>
            </button>
          </div>
        </div>
      </div>

      <div class="editor-preview certificate-email">
        <div class="preview-chrome email">
          <span [innerHTML]="'flipto.account.platform.Inbox' | translate"></span>
        </div>

        <div class="preview-content">
          <div class="preview-header limit-md">
            <span class="preview-label non-editable-content">{{ 'flipto.account.platform.Subject' | translate }}: </span>
            <div class="email-subject editable-content" ft-modal-fields-editor (click)="editSubject()">
              <div class="ft-label">{{ 'flipto.account.platform.Subject' | translate }}:</div>
              <div [innerHTML]="trust(langData('subject'))"></div>
            </div>
            <hr />
          </div>

          <div class="preview-body limit-md">
            <div class="email-body editable-content" ft-modal-fields-editor (click)="editBody()">
              <div class="ft-label">{{ 'flipto.account.Body' | translate }}:</div>
              <div [innerHTML]="trust(langData('body'))"></div>
            </div>

            <div class="email-signature non-editable-content">
              {{ '{sender-firstname} from {property}' }}
            </div>

            <div class="preview-certificate-link non-editable-content">
              <div class="preview-pane">
                <div class="preview-incentive-name">{{ '{incentive-name}' }}</div>
                <div class="preview-button">View your certificate</div>
              </div>
              <div class="preview-certificate-expiration">{{ '{certificate-expiration}' }}</div>
            </div>
          </div>
        </div>

        <div class="preview-options">
          <ft-language-selector-ng [languages]="model().languages" [selectedLanguage]="model().selectedLanguage"
                                   (selectedLanguageChange)="model().selectedLanguage = $event" />
          <a class="launch-preview" (click)="sendTestEmail()" [class.disabled]="!langData('is_can_send_sample_email')"
             [ftDisabled]="!langData('is_can_send_sample_email')">
            {{ 'flipto.account.EmailSample' | translate }} <i class="fa fa-envelope-o"></i>
          </a>
          <a class="launch-preview" (click)="showEmailHtml()" [class.disabled]="!langData('is_can_send_sample_email')"
             [ftDisabled]="!langData('is_can_send_sample_email')">
            Preview HTML <i class="ft-icn-external-link"></i>
          </a>
        </div>
      </div>

      @if (hasContestContentToken) {
        <div class="ft-panel" ft-modal-fields-editor (click)="editContestContent()">
          <div class="ft-row">
            <div class="ft-col-33">
              <div class="ft-label">{{ 'flipto.account.ContestContent' | translate }}:</div>
              <div class="ft-summary">{{ 'flipto.account.ContestContentSummary' | translate }}</div>
            </div>
            <div class="ft-col-66">
              <div [innerHTML]="trust(langData('contest_content'))"></div>
            </div>
          </div>
        </div>
      }
    </div>
  </section>
</section>
